import React from 'react';
import Component from '@vfuk/core-image-picker';
const ImagePicker = props => {
    return React.createElement(Component, Object.assign({}, props));
};
export default ImagePicker;
